import React from "react";
import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../../StateManagement/actions";

export function ContactsList({ contacts = [], onEdit, onDelete, onAddNew, isReadOnlyScope = false, selectedIds = new Set(), onToggleSelect, onSelectAll, isAllSelected = false }) {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const loggedInUser = (localStorage.getItem("UserName") || localStorage.getItem("userEmail") || "").toLowerCase().trim();
  const userRole = localStorage.getItem("UserRole") || "";
  const isAdmin = userRole === "RDocsCompanyAdmin" || userRole === "RDocsSupportAdmin" || userRole === "Admin";

  if (!contacts || contacts.length === 0) {
    return (
      <div className="contacts-empty-container">
        <div className="contacts-empty-icon">
          <span className="material-icons font-32">person_outline</span>
        </div>
        <h4 className="contacts-empty-title">
          {selectedLanguage?.LstLanguageCodes?.UI_NoContactsFound}
        </h4>
        <p className="contacts-empty-text">
          {selectedLanguage.LstLanguageCodes.UI_AddNewContactToGetStartedWithDirectory}
        </p>
      </div>
    );
  }

  return (
    <div className="contacts-table-scroll">
      <table className="contacts-table">
        <thead>
          <tr>
            <th className="text-center cursor-pointer" style={{ width: "44px", minWidth: "44px", padding: "0" }} onClick={onSelectAll}>
              <div className="checkbox mt-0 mb-0 d-inline-flex align-items-center justify-content-center">
                <label className="ps-0 mb-0 cursor-pointer" onClick={(e) => e.stopPropagation()}>
                  <input type="checkbox" checked={isAllSelected && contacts.length > 0} onChange={onSelectAll} />
                  <span className={`cr ${isAllSelected && contacts.length > 0 ? "checked" : ""}`}>
                    <svg className="cr-icon-svg" viewBox="0 0 24 24" width="11" height="11" stroke="#ffffff" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <i className="cr-icon material-icons">check</i>
                  </span>
                </label>
              </div>
            </th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_Name}</th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_Email}</th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_Mobile}</th>
            <th>{selectedLanguage?.LstLanguageCodes?.UI_CreatedBy}</th>
            <th className="contacts-table-actions-header">
              {selectedLanguage?.LstLanguageCodes?.UI_Actions}
            </th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact) => {
            const contactId = contact.id || contact.email;
            const isSelected = selectedIds.has(contactId);
            const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(" ");
            const createdByEmail = (contact.createdBy || contact.createdUser || "").toLowerCase().trim();
            const isCreator = Boolean(loggedInUser && createdByEmail && (loggedInUser === createdByEmail || createdByEmail.includes(loggedInUser)));
            const isReadOnly = (Boolean(contact.isReadOnly) || isReadOnlyScope) && !isCreator && !isAdmin;

            return (
              <tr key={contactId} className={isReadOnly ? "contacts-row-readonly" : "cursor-pointer"} onClick={() => !isReadOnly && onToggleSelect && onToggleSelect(contactId)}>
                {/* Checkbox (Disabled for Read-Only Contacts) */}
                <td className="text-center" style={{ width: "44px", minWidth: "44px", padding: "0" }} onClick={(e) => e.stopPropagation()}>
                  <div className="checkbox mt-0 mb-0 d-inline-flex align-items-center justify-content-center">
                    <label className={`ps-0 mb-0 ${isReadOnly ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}>
                      <input type="checkbox" disabled={isReadOnly} checked={!isReadOnly && isSelected} onChange={() => !isReadOnly && onToggleSelect && onToggleSelect(contactId)} />
                      <span className={`cr ${!isReadOnly && isSelected ? "checked" : ""} ${isReadOnly ? "contacts-cr-disabled" : ""}`}>
                        <svg className="cr-icon-svg" viewBox="0 0 24 24" width="11" height="11" stroke="#ffffff" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <i className="cr-icon material-icons">check</i>
                      </span>
                    </label>
                  </div>
                </td>

                {/* Name */}
                <td title={fullName || ""}>
                  <div className="text-truncate font-13 text-dark" title={fullName || ""}>
                    {fullName}
                  </div>
                </td>

                {/* Email */}
                <td title={contact.email || ""}>
                  <div className="text-truncate font-13" title={contact.email || ""}>
                    {contact.email}
                  </div>
                </td>

                {/* Mobile */}
                <td title={contact.mobile ? `${contact.phoneCode || ""} ${contact.mobile}` : ""}>
                  <div className="text-truncate font-13" title={contact.mobile ? `${contact.phoneCode || ""} ${contact.mobile}` : ""}>
                    {contact.mobile ? `${contact.phoneCode || ""} ${contact.mobile}` : ""}
                  </div>
                </td>

                {/* Created By */}
                <td title={contact.createdBy || ""}>
                  <div className="text-truncate font-13" title={contact.createdBy || ""}>{contact.createdBy}</div>
                </td>

                {/* Actions */}
                <td className="contacts-table-actions-cell" onClick={(e) => e.stopPropagation()}>
                  {isReadOnly ? (
                    <span className="badge bg-light text-muted border font-11 px-2 py-1">
                      Read-Only
                    </span>
                  ) : (
                    <div className="d-inline-flex align-items-center">
                      <span className="material-icons contacts-action-icon edit-icon me-3" title={selectedLanguage?.LstLanguageCodes?.UI_Edit} onClick={() => onEdit(contact)}>
                        edit
                      </span>
                      <span className="material-icons contacts-action-icon delete-icon" title={selectedLanguage?.LstLanguageCodes?.UI_Delete} onClick={() => onDelete(contact)}>
                        delete
                      </span>
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ContactsList;